import { CriteriaController } from "@js/controllers/CriteriaController";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { EnterpriseService } from "@js/services/EnterpriseService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  BridgingDeal,
  BridgingDealClient,
  CaseStatusEnum,
  Client,
  DealClient,
  DealSourceTypeEnum,
  LandOrPropertyEnum,
  LenderClient,
  LinkSourceTypeEnum,
  LinkTypeEnum,
  LoanCompletionTypeEnum,
  LocationEnum,
  Organisation,
  OrganisationClient,
  OrganisationLink,
  OrganisationLinkClient,
  OrganisationLinkCrudClient,
  OriginatorRoleTypeEnum,
  OwnOrPurchaseEnum,
  PlanningPermissionTypeEnum,
  PostalAddress,
  ProductFamilyEnum,
  ProductTypeEnum,
  PropertyTypeEnum,
  RefurbishmentLevelEnum,
  SaveBridgingSearchRequest,
  SaveSearchReturnUniqueRefResponse,
  ShareDealDTO,
  UserClient,
  UserRoleEnum,
  UserSimpleDTO,
  YesNoMaybe,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { OrganisationService } from "@js/services/OrganisationService";
import { BridgingDealService } from "@js/services/Deal/BridgingDealService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class BridgingCriteriaController extends CriteriaController<BridgingDeal> {
  isSaving: boolean = false;
  hasError: boolean = false;

  productType: ProductTypeEnum;

  dealDto: BridgingDeal;
  tempDealDto: BridgingDeal;
  snapshotDealDto: BridgingDeal;
  classUses: {} = {};
  yesNoOptions = [];
  siteTypeOptions = [];
  showResidual: boolean = false;
  showSummary: boolean = false;
  showKeyMatrix: boolean = false;
  isLoggedInUser: boolean = false;
  isSearchStarted: boolean = false;
  totalLenders: number;
  buildingConditionOptions = [];
  buildStageOptions = [];
  locationOptions = [];
  loanCompletionTypeOptions = [];
  refurbishmentLevelOptions = [];
  planningOptions = [];
  currentUseOptions = [];

  multiPartForm1: ng.IFormController;
  multiPartForm2: ng.IFormController;
  multiPartForm3: ng.IFormController;
  propertyForm: ng.IFormController;

  isBorrower: boolean = false;
  organisation: Organisation;
  moveContactBrokerBtnInMiddle: boolean = false;
  user: ApplicationUser = null;
  initialRegistrationClient: Client;
  orgCode: string = "";

  //Share a search modal
  showShareSearchtoClientModal: boolean = false;
  isResultScreen: boolean = false;
  existingborrower: boolean;
  profitBeforeCosts: number = 0;
  ROCE: number = 0;
  purchasePrice: number = 0;
  purchaseCosts: number = 0;
  GDV: number = 0;
  isSubmitted: boolean = false;
  showAutofill: boolean = false;
  error: string;

  //share search modal
  isBridging: boolean = true;

  guidanceCheckbox: boolean = true;
  maxPurchaseDate: Date = new Date();
  minPurchaseDate: Date = new Date("Jan 01 1900");
  minCompletionDate: Date;
  hasPurchasecostChanged: boolean = false;
  hasLandcostChanged: boolean = false;
  userRole: string = "";
  userDetails: string = null;
  projectName: string = null;
  clientId: number = null;
  //dataLoading: boolean = false;

  isFamilyInResidence: boolean = false;
  ownOrPurchase: boolean = false;
  landOrProperty: boolean = false;

  headingAdjustment: string;

  //Enterprise
  organisationLink: OrganisationLink;
  noPermissionErrorMsg: string = "";

  contingencyAmount: number = null;

  isAdmin: boolean = false;
  isBroker: boolean = false;
  isLender: boolean = false;

  isUniqueLink: boolean = false;

  //enterprise widget journey
  isMobileView: boolean = false;
  showHelpModal: boolean = false;
  loanInfoText: string;
  progressAmount: string = "50%";
  progressSection: number = 1;
  totalSections: number = 2;
  enterpriseLinkLogo: string;
  isWidget: boolean = false;

  //This property is used to show only postcode ot location field on critera for mobile view
  isCriteria: boolean = true;

  orgLinkSourceType: LinkSourceTypeEnum;

  //Helper text link
  showDevFinanceLink: boolean;

  static $inject = [
    "$scope",
    "$rootScope",
    "$routeParams",
    "$cookies",
    "$location",
    "$q",
    "CaseService",
    "UserClient",
    "ApplicationUserCrudClient",
    "RoleService",
    "OrganisationService",
    "OrganisationClient",
    "SelectListService",
    "LenderClient",
    "BridgingDealService",
    "BridgingDealClient",
    "AuthService",
    "OrganisationLinkClient",
    "BrickflowEventLogClient",
    "SharedCriteriaService",
    "DealClient",
    "EnterpriseService",
    "ODataHelper",
    "UserClient",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    private caseService: CaseService,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    private roleService: RoleService,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private selectListService: SelectListService,
    private lenderClient: LenderClient,
    private bridgingDealService: BridgingDealService,
    private bridgingDealClient: BridgingDealClient,
    private $auth: AuthService,
    organisationLinkClient: OrganisationLinkClient,
    eventLogClient: BrickflowEventLogClient,
    sharedCriteriaService: SharedCriteriaService,
    dealService: DealClient,
    private enterpriseService: EnterpriseService,
    odataHelper: ODataHelper,
  ) {
    super(
      dealService,
      $routeParams,
      odataHelper,
      organisationLinkClient,
      sharedCriteriaService,
      applicationUserCrudClient,
      userClient,
      eventLogClient,
    );
    this.init();
  }

  async init() {
    try {
      if (this.$routeParams.linkId) {
        this.orgLinkId = Number(this.$routeParams.linkId);
      }

      if (this.$routeParams.context == "widget") {
        if (window.self != window.top) {
          this.isWidget = true;
        } else {
          this.noPermissionErrorMsg =
            "This URL is designed to be embedded into a site, as a widget. If you would like the user to access this search directly, please use an Enterpise link.";
        }
      } else {
        if (window.innerWidth <= 480) this.isMobileView = true;
      }

      // If this is enterprise then don't do anythign else until we have the enterprise OrganisationLink.Id
      if (!this.$cookies.get("access_token") && this.isValidEnterprisePath()) {
        if (window.self == window.top) {
          this.orgCode = this.$cookies.get("org_code") ?? null;
        } else {
          this.orgCode = location.pathname.replace("/", "");
        }

        if (this.$routeParams.uniqueId) {
          await this.getProductFamiliesByUniqueId();
        }

        await this.getEnterpriseOrganisationByOrgCode();

        if (this.orgLinkId === null || this.orgLinkId === undefined || this.orgLinkId === 0) {
          await this.getEnterpriseLinkId();
        }

        if (this.orgLinkId !== null && this.orgLinkId !== undefined) {
          const linkSourceType = await this.organisationLinkClient.getLinkSourceType(this.orgLinkId);
          if (linkSourceType !== null && linkSourceType !== undefined) {
            this.orgLinkSourceType = linkSourceType;
          } else {
            this.noPermissionErrorMsg = "We are unable to compare loans right now. Please contact your broker.";
            return;
          }
        }
      }

      if (!this.isWidget && this.$routeParams.context == "widget")
        if (this.dealDto == null) {
          this.dealDto = {} as BridgingDeal;
        }

      //Enteprise journey code
      if (!this.$cookies.get("access_token") && this.isValidEnterprisePath()) {
        this.isBorrower = true;

        if (this.$location.path().startsWith("/e/bridgingcriteria")) {
          const imgs = document.getElementsByTagName("img");
          this.enterpriseLinkLogo = imgs[0].src;
          // this.sharedCriteriaService.storeEnterpriseLinkType(LinkTypeEnum.Bridging.toString());
          this.sharedCriteriaService.setPreviousUrl(this.$location.absUrl());
        }

        if (this.isWidget) {
          this.organisationService.sendDataToParent("height", "745px");
        }

        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.orgCode = this.$cookies.get("org_code") ?? null;
            sessionStorage.setItem("userRole", UserRoleEnum.Client.toString());
          } else {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("userRole", UserRoleEnum.Client.toString());
          }

          this.logEventWithoutDealData();
        }
      }

      if (window.self == window.top && this.$cookies.get("access_token")) {
        this.isLoggedInUser = true;

        this.userClient.getCurrentUserAutofill().then((response) => {
          this.showAutofill = response;
        });

        this.roleService
          .GetUserRoles()
          .then((result) => {
            if (result.filter((x) => x.toLowerCase() == "admin").length > 0) {
              this.isAdmin = true;
            }
            if (result.filter((x) => x.toLowerCase() == "broker").length > 0) {
              this.isBroker = true;
              //This block is to navigate a broker to userdashboard when they do not have a license.
              if (this.isBroker) {
                if (sessionStorage.getItem("isValidLicense") == "false") {
                  this.gotoDashboard();
                }
              }
            }
            if (result.filter((x) => x.toLowerCase() == "lender").length > 0 && !this.isAdmin) {
              this.isLender = true;
            }

            if (result.filter((x) => x.toLowerCase() == "client").length > 0 && !this.isAdmin) {
              this.isBorrower = true;
            }
          })
          .finally(() => {
            if (this.$auth.getHasValidStatustoShowShareSearchModal()) {
              if (sessionStorage.getItem("skip")) {
                //This will hide's a share search to client modal
                this.showShareSearchtoClientModal = false;
              } else {
                //getting a previously entered DealName and Client data
                if (DealHelper.getShowSearchNameAndUserSelectionModal()) {
                  this.showShareSearchtoClientModal = true;
                  this.getUsersBelongToBrokerOrAdmin();
                } else {
                  this.shareDealDto.clientDto = DealHelper.getClient();
                  this.shareDealDto.dealName = DealHelper.getDealName();
                }
              }
            }
            this.getOriginatorInfoForUser();
          });
      } else {
        if (!this.$routeParams.DealUniqueRef || this.$routeParams.DealUniqueRef == "0") {
          if (window.self == window.top) {
            this.clientId = parseInt(sessionStorage.getItem("clientId"));
          } else {
            Promise.all([
              this.organisationService.getData("clientId").then((clientId) => {
                if (clientId) {
                  this.clientId = Number(clientId);
                }
              }),
            ]);
          }
        }
      }

      if (this.$routeParams.DealUniqueRef && this.$routeParams.DealUniqueRef != "0") {
        this.dataLoading = true;
        this.dealService
          .fetchByUniqueRef(this.$routeParams.DealUniqueRef)
          .then((response) => {
            this.postRetrieveProcessing(response);
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else if (this.$routeParams.SearchId > 0) {
        this.dataLoading = true;
        this.bridgingDealClient
          .fetch(this.$routeParams.SearchId)
          .then((response) => {
            this.postRetrieveProcessing(response);
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.bridgingTypeChanged(ProductTypeEnum.BridgingPurchaseOrRefinance);
      }

      this.caseService.updateTubeMap(CaseStatusEnum.Search);
      this.buildStageOptions = this.selectListService.GetBuildStageOptions();
      this.locationOptions = this.selectListService.GetLocations();
      this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
      this.refurbishmentLevelOptions = this.selectListService.GetRefurbishmentLevelOptions();
      this.planningOptions = this.selectListService.GetPlanningPermissionTypesOfBridging();
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  async getEnterpriseOrganisationByOrgCode() {
    await this.organisationClient
      .getOrgByUrlIfOrgHasEnterpriseSearchPermission(
        this.orgCode,
        ProductFamilyEnum.Bridging,
        this.orgLinkId !== null ? this.orgLinkId.toString() : null,
      )
      .then((response) => {
        if (response) {
          this.organisation = response;
          this.orgCode = response.organisationCode;

          if (this.orgLinkId) {
            if (this.$location.path().startsWith("/e/bridgingcriteria")) {
              this.organisationLinkClient
                .getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(this.orgLinkId, "", 0, ProductTypeEnum.None, "", 0)
                .then((logoUrl) => {
                  const imgs = document.getElementsByTagName("img");
                  if (logoUrl != null && logoUrl.length > 0) this.enterpriseLinkLogo = imgs[0].src = logoUrl;
                });
            }
          }
        } else {
          this.logEvent("BRIDGINGCRITERIA-NO-PERMISSION-TO-SEARCH");
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
        }
      })
      .finally(() => {});
  }
  async getEnterpriseLinkId() {
    const linkType = this.$location.path().startsWith("/allloans") ? LinkTypeEnum.AllLoans : LinkTypeEnum.Bridging;

    try {
      // This is an enterprise link without an org link ID, so look up the ID
      await this.organisationLinkClient.getEnterpriseLinkId(this.organisation.id, linkType).then((linkId) => {
        if (linkId !== null || linkId !== undefined || linkId !== 0) {
          this.orgLinkId = linkId;
        } else {
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
          return;
        }
      });
    } catch (err) {
      this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
      return;
    }
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  getBuildCosts() {
    var buildCosts = +this.dealDto.estimatedSpending + +this.dealDto.purchasePrice;
    if (isNaN(buildCosts) || buildCosts == undefined) {
      buildCosts = 0;
    }
    return buildCosts;
  }

  getProfitBeforeCosts() {
    this.profitBeforeCosts =
      this.dealDto.gdv - this.dealDto.purchasePrice - this.dealDto.estimatedSpending - this.dealDto.purchaseCosts;
    if (isNaN(this.profitBeforeCosts)) {
      this.profitBeforeCosts = 0;
    }
    return this.profitBeforeCosts;
  }

  /* // updateGuidanceState() {
   //   this.guidanceCheckbox =
   //     this.$cookies.get("guidance") === "on" ||
   //     this.$cookies.get("guidance") === undefined;
   //   // Update tour settings
   // }
 
   // getGuidanceSwitchState() {
   //   if (!this.$cookies.get("guidance")) {
   //     this.guidanceCheckbox = true;
   //   } else if (this.$cookies.get("guidance") === "on") {
   //     this.guidanceCheckbox = true;
   //   } else if (this.$cookies.get("guidance") === "off") {
   //     this.guidanceCheckbox = false;
   //   } else {
   //     this.guidanceCheckbox = true;
   //   }
   //   return this.guidanceCheckbox;
   // }
 
   // recordGuidanceCookie() {
   //   var guidanceSwitchState: string;
   //   var expiryDate = new Date();
   //   expiryDate.setDate(expiryDate.getDate() + 365);
   //   if (this.guidanceCheckbox == true) {
   //     guidanceSwitchState = "on";
   //   } else {
   //     guidanceSwitchState = "off";
   //   }
   //   this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
   //   this.$rootScope.$broadcast("guidanceStateChanged");
   // }
 
   //getROCE() {
   //    this.ROCE = (this.dealDto.gdv / this.totalCosts) * 100;
   //    if (isNaN(this.ROCE)) {
   //        this.ROCE = 0;
   //    }
   //    return this.ROCE.toFixed(2);
   //}
 
   //getPurchasePrice() {
   //    this.purchasePrice = this.dealDto.purchasePrice;
   //    if (isNaN(this.purchasePrice)) {
   //        this.purchasePrice = 0;
   //    }
   //    return this.purchasePrice;
   //}
 
   //getPurchaseCosts() {
   //    this.purchaseCosts = this.dealDto.purchaseCosts;
   //    if (isNaN(this.purchaseCosts)) {
   //        this.purchaseCosts = 0;
   //    }
   //    return this.purchaseCosts;
   //}
 
   //getGDV() {
   //    if (isNaN(this.dealDto.gdv) || this.dealDto.gdv == undefined) {
   //        this.dealDto.gdv = 0;
   //    } else {
   //        this.dealDto.gdv = this.dealDto.gdv;
   //    }
   //    return this.dealDto.gdv;
   //}
 */
  goToSearchResults() {
    this.hasError = false;
    this.error = null;
    this.isSubmitted = true;
    this.enterpriseService.setProductFamily(this.dealDto.productFamily);
    // If enterprise
    this.isSearchStarted = true;
    if (!this.isLoggedInUser && this.isBorrower && this.isValidEnterprisePath()) {
      this.saveCriteriaReturnUniqueRef().then((response) => {
        if (!this.hasError) {
          this.sharedCriteriaService.setIsDataLoading(false);
          var response = response as SaveSearchReturnUniqueRefResponse;
          if (window.self == window.top) sessionStorage.removeItem("productType");

          if (response.hasDealClient) {
            //The purpose of the route check is to ensure navigation to the correct route when the user lands on the criteria page by clicking 'Change Search' in the side panel.
            if (sessionStorage.getItem("previousRoute") == "referredsearchdeal") {
              this.$location.path(`/referredsearchdeal/${response.dealClientUniqueRef}/false`);
              sessionStorage.removeItem("previousRoute");
            } else {
              this.$location.path(`/e/bridgingresults/${response.dealUniqueRef}`);
            }
          } else {
            var leadCaptureUrl = `/e/enterpriseleadcapture/${response.dealUniqueRef}`;
            leadCaptureUrl = this.isWidget ? `${leadCaptureUrl}/widget` : leadCaptureUrl;

            this.$location.path(leadCaptureUrl);
          }
        }
      });
    } else {
      this.saveCriteriaReturnId().then((response) => {
        if (!this.hasError) {
          var dealId = response as number;
          if (window.self == window.top) sessionStorage.removeItem("productType");

          if (this.isAdmin || this.isBroker) DealHelper.setShowSearchNameAndUserSelectionModal(true);
          this.$location.path("/bridgingresults/" + dealId);
        }
      });
    }
  }

  getTubeMapValue() {
    return this.caseService.getTubeMap();
  }

  getNumberOfLenders() {
    if (this.dealDto && this.dealDto.productType) {
      //TODO Bridging JS: replacing ProductTypeEnum.BridgingPreconstruction with this.productType assuming that preconstruction products will not apply to all product types.
      this.lenderClient.getTotalLenders(ProductFamilyEnum.Bridging).then((response: number) => {
        this.totalLenders = Math.floor(response);
      });
    } else {
      //TODO what should it default to?
    }
  }

  go(path: string): void {
    this.$location.path(path);
  }

  saveCriteriaReturnId(): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    this.dataSetUpForSave();

    const clientDto = null;

    const request: SaveBridgingSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isLoggedInUser && this.clientId && !this.user && this.isValidEnterprisePath() ? Number(this.clientId) : 0,
      enterpriseClientDto: clientDto,
    };

    this.bridgingDealClient
      .saveBridgingSearchReturnsId(request)
      .then((response) => {
        this.dealDto.id = response;
        this.isSaving = false;

        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  saveCriteriaReturnUniqueRef(): ng.IPromise<SaveSearchReturnUniqueRefResponse> {
    let defer = this.$q.defer<SaveSearchReturnUniqueRefResponse>();
    this.sharedCriteriaService.setIsDataLoading(true);
    this.dataSetUpForSave();

    const clientDto = null;

    const request: SaveBridgingSearchRequest = {
      deal: this.dealDto,
      shareDealDto: this.shareDealDto,
      orgCode: this.isLoggedInUser ? "" : this.orgCode,
      clientId:
        !this.isWidget && !this.isLoggedInUser && this.clientId && !this.user && this.isValidEnterprisePath()
          ? Number(this.clientId)
          : 0,
      enterpriseClientDto: clientDto,
      sourceUrl: this.isLoggedInUser ? "" : this.sharedCriteriaService.getPreviousUrl(),
    };

    this.bridgingDealClient
      .saveBridgingSearchReturnsUniqueRef(request)
      .then((response) => {
        this.dealDto.uniqueRef = response.dealUniqueRef;
        this.isSaving = false;

        defer.resolve(response as SaveSearchReturnUniqueRefResponse);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        this.sharedCriteriaService.setIsDataLoading(false);
        if (response.status === 500) {
          this.error = response.data.message;
        } else {
          this.error = "Something went wrong while searching for loans. Please try again.";
        }
        this.hasError = true;
        this.isSearchStarted = false;
      });

    return defer.promise;
  }

  dataSetUpForSave() {
    this.sharedCriteriaService.setNewSearch(this.dealDto, this.snapshotDealDto);

    if (this.dealDto.id == null) {
      this.dealDto.status = CaseStatusEnum.Search;
    }

    if (this.dealDto.name == null || this.dealDto.name == "" || this.dealDto.name == undefined) {
      //Lender referred search
      if (sessionStorage.getItem("lenderReferralReference")) {
        this.dealDto.name = sessionStorage.getItem("lenderReferralReference");
      } else {
        this.dealDto.name = this.sharedCriteriaService.defaultSearchName(
          this.dealDto.productType,
          this.dealDto.hasIsFamilyInResidence &&
            (this.dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
              this.dealDto.productType == ProductTypeEnum.BridgingRefurb),
        );
      }
    }

    if (!this.isLoggedInUser && this.isValidEnterprisePath() && this.isBorrower) {
      this.dealDto.howManyFlats = this.dealDto.howManyFlats ? this.dealDto.howManyFlats : 0;
      this.dealDto.howManyHouses = this.dealDto.howManyHouses ? this.dealDto.howManyHouses : 0;
    }

    if (!this.shareDealDto) {
      this.shareDealDto = {
        dealName: this.sharedCriteriaService.defaultSearchName(
          this.dealDto.productType,
          this.dealDto.hasIsFamilyInResidence &&
            (this.dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
              this.dealDto.productType == ProductTypeEnum.BridgingRefurb),
        ),

        accessLevel: undefined,
        clientDto: undefined,
        dealId: 0,
        emailLinkToClient: false,
        isApplicant: false,
        isPrimary: false,
        showLenderNamesAndLogos: false,
      };
    } else {
      if (this.shareDealDto && this.shareDealDto.clientDto) {
        this.shareDealDto.clientDto.id = this.shareDealDto.clientDto.id ?? 0;
        this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
    }
  }

  getUsersBelongToBrokerOrAdmin() {
    this.userClient
      .getUserSummariesForBrokerOrAdmin()
      .then((response) => {
        this.existingUsers = response;
      })
      .finally(() => {});
  }

  onClickOfNext() {
    this.showShareSearchtoClientModal = false;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
      DealHelper.setClient(this.shareDealDto.clientDto);
      DealHelper.setDealName(this.shareDealDto.dealName);
    }
  }

  OnClickOfSkip() {
    this.showShareSearchtoClientModal = false;
    this.shareDealDto.clientDto = null;
    if (this.$location.path().startsWith("/allloans") && (this.isAdmin || this.isBroker)) {
      DealHelper.setShowSearchNameAndUserSelectionModal(false);
    }
  }

  gotoDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  goToUserDashboard() {
    this.gotoDashboard();
  }

  searchDisabledPrecon() {
    var commonFields: (LocationEnum | OwnOrPurchaseEnum | YesNoMaybe | LandOrPropertyEnum | PropertyTypeEnum)[] = [
      this.dealDto.ownOrPurchase,
      this.dealDto.locations,
      this.dealDto.isFamilyInResidence,
      this.dealDto.landOrProperty,
    ];

    if (this.progressSection == 1) {
      this.progressAmount = "0%";
      if (this.dealDto.landOrProperty == LandOrPropertyEnum.Property)
        commonFields = [...commonFields, this.dealDto.endPropertyType];

      if (this.dealDto.hasPostcode && !this.dealDto.postcodeSearchString) {
        return true;
      }

      if (!this.dealDto.hasPostcode && !this.dealDto.locations) {
        return true;
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      if (this.dealDto.isFamilyInResidence == 0 || this.dealDto.isFamilyInResidence == YesNoMaybe.Yes) return true;

      if (this.dealDto.planningPermissionType == null || this.dealDto.planningPermissionType < 1) {
        return true;
      }

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == PropertyTypeEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None
        ) {
          return true;
        }
      }

      this.progressAmount = "50%";
    }

    if (this.progressSection == 2) {
      this.progressAmount = "50%";

      if (!DealHelper.showBasedOnMainResidence(this.dealDto) || this.hasValidNetLoanRequiredValue()) {
        return true;
      }

      commonFields = [...commonFields, this.dealDto.purchasePrice, this.dealDto.loanTermReq];

      if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        let commonOwnFields = [
          this.dealDto.originalPurchaseDate,
          this.dealDto.currentvalue,
          this.dealDto.landTotalOtherCosts,
        ];
        for (let i = 0; i < commonOwnFields.length; i++) {
          if (commonOwnFields[i] == null) {
            return true;
          }
        }
        if (
          this.dealDto.landOrProperty == LandOrPropertyEnum.Land &&
          this.dealDto.ownOrPurchase != OwnOrPurchaseEnum.Own
        ) {
          let commonLandFields = [this.dealDto.purchaseCosts, this.dealDto.estimatedSpending];
          for (let i = 0; i < commonLandFields.length; i++) {
            if (commonLandFields[i] == null) {
              return true;
            }
          }
          if (this.dealDto.isMortgaged) {
            if (this.dealDto.mortgageCurrentLender == null || this.dealDto.mortgageCurrentLender == "") {
              return true;
            }
          }
        } else if (this.dealDto.ownOrPurchase != OwnOrPurchaseEnum.Own) {
          let commonPropFields = [this.dealDto.endPropertyType];
          for (let i = 0; i < commonPropFields.length; i++) {
            if (commonPropFields[i] == null || commonPropFields[i] == PropertyTypeEnum.None) {
              return true;
            }
          }
        }
      }

      if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
        let commonPurchFields = [
          this.dealDto.purchaseCosts,
          //this.dealDto.estimatedSpending
        ];
        for (let i = 0; i < commonPurchFields.length; i++) {
          if (commonPurchFields[i] == null) {
            return true;
          }
        }
        if (this.dealDto.landOrProperty == LandOrPropertyEnum.Property) {
          let commonPropFields = [this.dealDto.endPropertyType];
          for (let i = 0; i < commonPropFields.length; i++) {
            if (commonPropFields[i] == null || commonPropFields[i] == PropertyTypeEnum.None) {
              return true;
            }
          }
        }
      }

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None
        ) {
          return true;
        }
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      this.progressAmount = "100%";
    }

    return false;
  }

  searchDisabledPurchaseOrRefinance() {
    this.progressAmount = "50%";

    let commonFields = [
      this.dealDto.ownOrPurchase,
      this.dealDto.locations,
      this.dealDto.isFamilyInResidence,
      this.dealDto.landOrProperty,
      this.dealDto.endPropertyType,
    ];

    if (this.progressSection == 1) {
      this.progressAmount = "0%";

      if (this.dealDto.hasPostcode && !this.dealDto.postcodeSearchString) {
        return true;
      }

      if (!this.dealDto.hasPostcode && !this.dealDto.locations) {
        return true;
      }

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None
        ) {
          return true;
        }
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      if (this.dealDto.landOrProperty == LandOrPropertyEnum.Land) {
        return true;
      }

      this.progressAmount = "50%";
    }

    if (this.progressSection == 2) {
      this.progressAmount = "50%";
      if (!DealHelper.showBasedOnMainResidence(this.dealDto) || this.hasValidNetLoanRequiredValue()) {
        return true;
      }

      commonFields = [...commonFields, this.dealDto.purchasePrice, this.dealDto.loanTermReq];

      if (this.dealDto.purchaseCosts == null) {
        return true;
      }

      if (this.dealDto.isPropertyImprovementDuringLoanTerm) {
        let commonImprovementFields = [this.dealDto.estimatedSpending, this.dealDto.gdv];
        for (let i = 0; i < commonImprovementFields.length; i++) {
          if (commonImprovementFields[i] == null) {
            return true;
          }
        }
      }

      if (this.dealDto.isMortgaged) {
        if (this.dealDto.mortgageCurrentLender == null || this.dealDto.mortgageCurrentLender == "") {
          return true;
        }
      }

      if (!this.dealDto.maxLoanRequired) {
        if (this.dealDto.netLoanRequired == null) {
          return true;
        }
      }

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None
        ) {
          return true;
        }
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      this.progressAmount = "100%";
    }
  }

  searchDisabledBridgingDeveloperExit() {
    var commonFields = [
      this.dealDto.locations,
      this.dealDto.isFamilyInResidence,
      this.dealDto.endPropertyType,
      this.dealDto.refinancedUnits,
    ];

    if (this.progressSection == 1) {
      this.progressAmount = "0%";

      if (this.dealDto.hasPostcode && !this.dealDto.postcodeSearchString) {
        return true;
      }

      if (!this.dealDto.hasPostcode && !this.dealDto.locations) {
        return true;
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      if (this.dealDto.isFamilyInResidence == 0 || this.dealDto.isFamilyInResidence == YesNoMaybe.Yes) return true;

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == PropertyTypeEnum.None
        ) {
          return true;
        }
      }
      this.progressAmount = "50%";
    }

    if (this.progressSection == 2) {
      this.progressAmount = "50%";

      if (!DealHelper.showBasedOnMainResidence(this.dealDto) || this.hasValidNetLoanRequiredValue()) {
        return true;
      }
      commonFields = [...commonFields, this.dealDto.currentvalue, this.dealDto.loanTermReq];

      if (!this.dealDto.maxLoanRequired) {
        if (this.dealDto.netLoanRequired == null) {
          return true;
        }
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == PropertyTypeEnum.None
        ) {
          return true;
        }
      }

      this.progressAmount = "100%";
    }

    return false;
  }

  searchDisabledRefurb() {
    this.progressAmount = "50%";

    let commonFields = [
      this.dealDto.ownOrPurchase,
      this.dealDto.locations,
      this.dealDto.isFamilyInResidence,
      this.dealDto.landOrProperty,
      this.dealDto.endPropertyType, // TODO - will "Current use of building" be a different property to this one???
      this.dealDto.purchasePrice,
      this.dealDto.refurbishmentLevel,
    ];

    if (this.progressSection == 1) {
      this.progressAmount = "0%";

      if (this.dealDto.hasPostcode && !this.dealDto.postcodeSearchString) {
        return true;
      }

      if (!this.dealDto.hasPostcode && !this.dealDto.locations) {
        return true;
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      if (this.dealDto.landOrProperty == LandOrPropertyEnum.Land) {
        return true;
      }

      if (this.dealDto.purchaseCosts == null) {
        return true;
      }

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None ||
          commonFields[i] == PropertyTypeEnum.None ||
          commonFields[i] == RefurbishmentLevelEnum.None
        ) {
          return true;
        }
      }

      this.progressAmount = "50%";
    }

    ////TODO current value when owned
    ////TODO purchase price when not owned ??? all the time?

    if (this.progressSection == 2) {
      this.progressAmount = "50%";

      if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        if (this.dealDto.currentvalue == null) return true;
        if (this.dealDto.originalPurchaseDate == null) return true;
      }

      if (!DealHelper.showBasedOnMainResidence(this.dealDto) || this.hasValidNetLoanRequiredValue()) {
        return true;
      }

      commonFields = [...commonFields, this.dealDto.buildCosts, this.dealDto.loanTermReq, this.dealDto.gdv];

      if (!this.dealDto.maxLoanRequired) {
        if (this.dealDto.netLoanRequired == null) {
          return true;
        }
      }

      if (this.multiPartForm1 && this.multiPartForm1.$invalid) return true;

      for (let i = 0; i < commonFields.length; i++) {
        if (
          commonFields[i] == null ||
          commonFields[i] == LocationEnum.None ||
          commonFields[i] == YesNoMaybe.NotfilledIn ||
          commonFields[i] == LandOrPropertyEnum.None ||
          commonFields[i] == PropertyTypeEnum.None ||
          commonFields[i] == RefurbishmentLevelEnum.None
        ) {
          return true;
        }
      }

      this.progressAmount = "100%";
    }

    return false;
  }

  searchDisabled() {
    if (this.dealDto === null || this.dealDto === undefined) return true;

    switch (this.dealDto.productType) {
      case ProductTypeEnum.BridgingPreconstruction:
        return this.searchDisabledPrecon();
      case ProductTypeEnum.BridgingPurchaseOrRefinance:
        return this.searchDisabledPurchaseOrRefinance();
      case ProductTypeEnum.BridgingDeveloperExit:
        return this.searchDisabledBridgingDeveloperExit();
      case ProductTypeEnum.BridgingRefurb:
        return this.searchDisabledRefurb();
      default:
        return true;
    }
  }

  dummysearch() {
    let date = new Date();
    date.setDate(date.getDate() - 1);

    this.dealDto.isFamilyInResidence = YesNoMaybe.No;
    this.dealDto.hasIsFamilyInResidence = false;

    this.dealDto.hasPostcode = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 1 ? true : false;

    if (this.dealDto.hasPostcode) {
      this.dealDto.postcodeSearchString = this.sharedCriteriaService.getRandomPostcode();
      this.getRegionByPostcode();
    } else {
      this.dealDto.locations = LocationEnum.London;
    }

    this.dealDto.ownOrPurchase = OwnOrPurchaseEnum.Own;
    this.dealDto.landOrProperty =
      this.dealDto.productType == ProductTypeEnum.BridgingRefurb
        ? LandOrPropertyEnum.Property
        : LandOrPropertyEnum.Land;

    //this.getPlanningOptions();
    this.dealDto.planningPermissionType =
      this.dealDto.productType == ProductTypeEnum.BridgingPreconstruction
        ? PlanningPermissionTypeEnum.NoPlanning
        : PlanningPermissionTypeEnum.None;

    this.dealDto.loanTermReq = this.sharedCriteriaService.getRandomIntInclusive(6, 18);
    this.dealDto.maxLoanRequired = this.sharedCriteriaService.getRandomIntInclusive(0, 1) == 1 ? true : false;

    switch (this.dealDto.productType) {
      case ProductTypeEnum.BridgingPreconstruction:
        this.dealDto.originalPurchaseDate = date;
        this.dealDto.landTotalOtherCosts = this.sharedCriteriaService.getRandomIntInclusive(10000, 20000);
        this.dealDto.purchasePrice = this.sharedCriteriaService.getRandomIntInclusive(5000000, 10000000);
        this.dealDto.currentvalue =
          this.dealDto.purchasePrice + this.sharedCriteriaService.getRandomIntInclusive(-2000000, 2000000);
        this.dealDto.netLoanRequired = !this.dealDto.maxLoanRequired
          ? this.dealDto.purchasePrice +
            this.dealDto.purchaseCosts +
            this.sharedCriteriaService.getRandomIntInclusive(100000, 4000000)
          : null;
        this.dealDto.purchaseCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
        break;

      case ProductTypeEnum.BridgingPurchaseOrRefinance:
        this.dealDto.hasLandOrProperty = true;
        this.onLandOrPropertyChange();
        this.dealDto.originalPurchaseDate = date;
        this.dealDto.landTotalOtherCosts = this.sharedCriteriaService.getRandomIntInclusive(10000, 20000);
        this.dealDto.purchasePrice = this.sharedCriteriaService.getRandomIntInclusive(5000000, 10000000);
        this.dealDto.currentvalue =
          this.dealDto.purchasePrice + this.sharedCriteriaService.getRandomIntInclusive(-2000000, 2000000);
        this.dealDto.netLoanRequired = !this.dealDto.maxLoanRequired
          ? this.dealDto.purchasePrice +
            this.dealDto.purchaseCosts +
            this.sharedCriteriaService.getRandomIntInclusive(100000, 4000000)
          : null;
        this.dealDto.purchaseCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
        break;

      case ProductTypeEnum.BridgingDeveloperExit:
        this.dealDto.refinancedUnits = this.sharedCriteriaService.getRandomIntInclusive(1, 5);
        this.dealDto.landOrProperty = LandOrPropertyEnum.Property;
        this.dealDto.currentvalue = this.sharedCriteriaService.getRandomIntInclusive(1000000, 5000000);
        this.dealDto.netLoanRequired =
          this.dealDto.currentvalue + this.sharedCriteriaService.getRandomIntInclusive(-100000, 100000);
        break;
      case ProductTypeEnum.BridgingRefurb:
        this.dealDto.refurbishmentLevel = RefurbishmentLevelEnum.Light;
        this.dealDto.buildCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
        this.dealDto.purchasePrice = this.sharedCriteriaService.getRandomIntInclusive(5000000, 10000000);
        this.dealDto.originalPurchaseDate = date;
        this.dealDto.currentvalue =
          this.dealDto.purchasePrice + this.sharedCriteriaService.getRandomIntInclusive(-2000000, 2000000);
        this.dealDto.purchaseCosts = this.sharedCriteriaService.getRandomIntInclusive(100000, 1000000);
        this.dealDto.gdv =
          this.dealDto.currentvalue + this.sharedCriteriaService.getRandomIntInclusive(2000000, 4000000);
        this.dealDto.netLoanRequired = !this.dealDto.maxLoanRequired
          ? this.dealDto.purchasePrice +
            this.dealDto.purchaseCosts +
            this.sharedCriteriaService.getRandomIntInclusive(100000, 4000000)
          : null;
    }
  }

  debugSearch() {
    const stringJSON = JSON.stringify(this.dealDto);
    navigator.clipboard
      .writeText(stringJSON)
      .then()
      .catch((e) => console.log(e));
  }

  //Clears the previously selected existing client data on share search modal
  clearInputFields() {
    this.shareDealDto = this.sharedCriteriaService.clearExistingUserOnShareDealDto(this.shareDealDto);
    this.showClientDetails = false;
  }

  // Setting the dependent data when option are changed
  clearSearchdata() {
    this.dealDto = this.bridgingDealService.clearSearchdata(this.dealDto);
  }

  isFieldEmpty(fieldName, isEnum = false) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldName == "PlanningPermissionType") {
        if (fieldValue == null || fieldValue < 1) {
          return true;
        }
      }
      if (fieldValue == null || (isEnum && fieldValue === "0")) {
        return true;
      }
    }

    return false;
  }

  isFieldZero(fieldName) {
    if (this.isSubmitted && this.dealDto) {
      const fieldValue = this.dealDto[fieldName];
      if (fieldValue == null || fieldValue === "0" || fieldValue === 0) {
        return true;
      }
    }

    return false;
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = this.bridgingDealService.datasetupOnOwnOrPurchaseChange(this.dealDto);
  }

  datasetupOnLandorPropertyChange() {
    this.dealDto = this.bridgingDealService.datasetupOnLandorPropertyChange(this.dealDto);
  }

  datasetupOnInterestServiceChange() {
    this.dealDto = this.bridgingDealService.datasetupOnInterestServiceChange(this.dealDto);
  }

  datasetupOnIsTenantedBuildingChange() {
    this.dealDto = this.bridgingDealService.datasetupOnIsTenantedBuildingChange(this.dealDto);
  }

  datasetupOnEndPropertyTypeChange() {
    if (
      this.dealDto.endPropertyType != PropertyTypeEnum.MixedUse &&
      this.dealDto.endPropertyType != PropertyTypeEnum.Residential
    ) {
      this.classUses = {};
    }
    this.dealDto = this.bridgingDealService.datasetupOnEndPropertyTypeChange(this.dealDto);
  }

  datasetupOnHasCompletionDateChange() {
    this.dealDto = this.bridgingDealService.datasetupOnHasCompletionDateChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
  }

  initClassUses() {
    let classUses: {} = {};
    for (let i = 1; i >= 0; i *= 2) {
      if (this.dealDto.classUses >= i) {
        //number is in enum sum, add it to object
        if (this.dealDto.classUses & i) {
          classUses[i] = true;
        }
      } else {
        this.classUses = classUses;

        //watch and update classuses
        this.$scope.$watchCollection("ctrl.classUses", (newVal: {}) => {
          let valuesList = Object.keys(newVal);
          let total: number = 0;
          //tot up all the numeric keys (class use enums)
          valuesList.forEach((v, i) => {
            let keyToNum = Number(v);
            if (newVal[keyToNum]) {
              total += keyToNum;
            }
          });
          this.dealDto.classUses = total;
        });

        return;
      }
    }
  }

  getProductRoute(): string {
    switch (this.dealDto.productType) {
      case ProductTypeEnum.BridgingPreconstruction:
        return "";
      case ProductTypeEnum.BridgingPurchaseOrRefinance:
        return "/PurchaseRefinance";
      case ProductTypeEnum.BridgingDeveloperExit:
        return "/DeveloperExit";
      case ProductTypeEnum.BridgingRefurb:
        return "/Refurbishment";
      default:
        return "";
    }
  }

  async bridgingTypeChanged(productType: ProductTypeEnum) {
    this.progressSection = 1;

    this.dealDto = {} as BridgingDeal;
    if (this.$cookies.get("access_token")) {
      this.getOriginatorInfoForUser();
    } else {
      this.getOriginatorInfoForAnonymousUsers();
    }
    this.dealDto.maxLoanRequired = true;
    this.dealDto.productType = productType;
    this.currentUseOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.dealDto.productFamily = ProductFamilyEnum.Bridging;
    this.getLoanInfoText();
    this.dealDto.hasIsFamilyInResidence = false;
    this.dealDto.isFamilyInResidence = YesNoMaybe.No;
    this.dealDto.hasOwnOrPurchase = false;
    this.dealDto.ownOrPurchase = OwnOrPurchaseEnum.Purchasing;
    this.dealDto.landOrProperty =
      this.dealDto.productType == ProductTypeEnum.BridgingPreconstruction
        ? LandOrPropertyEnum.Land
        : LandOrPropertyEnum.Property;

    this.dealDto.hasLandOrProperty =
      this.dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
      this.dealDto.productType == ProductTypeEnum.BridgingRefurb
        ? true
        : false;
    //this.getPlanningOptions();
    this.dealDto.planningPermissionType =
      this.dealDto.productType == ProductTypeEnum.BridgingPreconstruction
        ? PlanningPermissionTypeEnum.DetailedPlanning
        : PlanningPermissionTypeEnum.None;
    this.dealDto.loanCompletionType = LoanCompletionTypeEnum.JustCheckingMyOptions;
    this.dealDto.refurbishmentLevel =
      this.dealDto.productType == ProductTypeEnum.BridgingRefurb ? RefurbishmentLevelEnum.Light : null;
    this.dealDto.showLenderInfoBrokerOverride = true;
    this.dealDto.hasPostcode = true;
    this.hasPurchasecostChanged = false;
    this.hasLandcostChanged = false;
    if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
      if (this.orgLinkId !== null && this.$routeParams.linkId !== 0) {
        this.dealDto.organisationLinkId = this.orgLinkId;
      }

      this.logEvent("BRIDGINGCRITERIA-PAGE1");
    }
  }

  async getOriginatorInfoForUser() {
    if (this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Admin;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    } else if (this.isBroker && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Broker;
    } else if (this.isBorrower && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;
    } else if (this.isLender && !this.isAdmin) {
      this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Lender;
      this.dealDto.sourceType = DealSourceTypeEnum.Application;
    }

    if (window.self == window.top) {
      if (this.isLender) {
        this.userClient.getCurrentUserLender().then((response) => {
          this.dealDto.originatorLenderId = response;
        });
      }

      if (this.isBroker || this.isBorrower) {
        this.organisationService.getOrganisation().then((org) => {
          if (org != null) {
            if (org.id != 0) this.dealDto.originatorOrganisationId = org.id;
            this.dealDto.sourceType = org.isWhiteLabelled
              ? DealSourceTypeEnum.WhitelabelApplication
              : DealSourceTypeEnum.Application;
          }
        });
      }
    }
  }

  getOriginatorInfoForAnonymousUsers() {
    this.dealDto.originatorRoleType = OriginatorRoleTypeEnum.Borrower;

    if (window.self == window.top) {
      this.dealDto.sourceType = DealSourceTypeEnum.Enterprise;
    } else {
      this.dealDto.sourceType = this.isWidget
        ? DealSourceTypeEnum.WidgetEnterprise
        : DealSourceTypeEnum.IFrameEnterprise;
    }

    if (this.orgLinkId !== null && this.orgLinkId !== undefined) {
      const isEnterprise = window.self === window.top;
      const isManualUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Manual;
      const isEnterpriseUniqueLink = this.orgLinkSourceType === LinkSourceTypeEnum.Enterprise;

      if (isEnterprise) {
        this.dealDto.sourceType = isManualUniqueLink ? DealSourceTypeEnum.UniqueLink : DealSourceTypeEnum.Enterprise;
      } else if (this.isWidget) {
        this.dealDto.sourceType = isEnterpriseUniqueLink
          ? DealSourceTypeEnum.WidgetEnterprise
          : DealSourceTypeEnum.WidgetUniqueLink;
      } else {
        this.dealDto.sourceType = isManualUniqueLink
          ? DealSourceTypeEnum.IFrameUniqueLink
          : DealSourceTypeEnum.IFrameEnterprise;
      }
    }
  }

  calculatePurchaseOrLandCost() {
    if (this.dealDto.productType == ProductTypeEnum.BridgingPreconstruction) {
      if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        if (this.dealDto.purchasePrice && !this.hasLandcostChanged) {
          this.dealDto.landTotalOtherCosts = (this.dealDto.purchasePrice * 5) / 100;
        }
      } else if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
        if (this.dealDto.purchasePrice && !this.hasPurchasecostChanged) {
          this.dealDto.purchaseCosts = (this.dealDto.purchasePrice * 5) / 100;
        }
      }
    } else if (
      this.dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
      this.dealDto.productType == ProductTypeEnum.BridgingRefurb
    ) {
      if (this.dealDto.purchasePrice && !this.hasPurchasecostChanged) {
        this.dealDto.purchaseCosts = (this.dealDto.purchasePrice * 5) / 100;
      }
    }
  }

  onPurchaseCostChange() {
    var purchaseCost = (this.dealDto.purchasePrice * 5) / 100;
    if (this.dealDto.purchaseCosts != purchaseCost) {
      this.hasPurchasecostChanged = true;
    }
  }

  onLandCostChange() {
    var landCost = (this.dealDto.purchasePrice * 5) / 100;
    if (this.dealDto.purchaseCosts != landCost) {
      this.hasLandcostChanged = true;
    }
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    //this.getPlanningOptions();
    this.datasetupOnOwnOrPurchaseChange();
  }

  onLandOrPropertyChange() {
    this.dealDto.landOrProperty = this.dealDto.hasLandOrProperty
      ? LandOrPropertyEnum.Property
      : LandOrPropertyEnum.Land;
    //this.getPlanningOptions();
    this.datasetupOnLandorPropertyChange();
  }

  onIsFamilyInResidenceChange() {
    this.dealDto.isFamilyInResidence = this.dealDto.hasIsFamilyInResidence ? YesNoMaybe.Yes : YesNoMaybe.No;
  }

  initialDataSetupForIsFamilyInResidence() {
    if (this.dealDto.hasIsFamilyInResidence) {
      this.dealDto.isFamilyInResidence = YesNoMaybe.Yes;
      this.dealDto.hasIsFamilyInResidence = true;
    } else {
      this.dealDto.isFamilyInResidence = YesNoMaybe.No;
      this.dealDto.hasIsFamilyInResidence = false;
    }
  }

  goToLoanTypeSelectionPage() {
    if (this.isLoggedInUser) {
      this.$auth.setHasValidStatustoShowShareSearchModal(true);
    }

    this.$location.path("/allloans");
  }

  goToDevFinanceCriteria() {
    if (
      this.$routeParams.uniqueId ||
      this.$location.path().startsWith("/allloans") ||
      this.$routeParams.context == "widget"
    ) {
      this.$scope.$emit("productFamilySelection", 1);
    } else if (this.isLoggedInUser) {
      this.$location.path("/devfinancecriteria");
    } else {
      this.$location.path("/e/devfinancecriteria");
    }
  }

  calculateMonthsSinceOrigPurchase() {
    let date1 = new Date(this.dealDto.originalPurchaseDate);
    let date2 = new Date();
    let months;
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months;
  }

  async logEvent(identifier: string) {
    var orgCode;
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto?.organisationLinkId,
          this.dealDto.productType,
          "",
          this.dealDto.id,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto?.organisationLinkId,
          this.dealDto.productType,
        );
      }
    } else {
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));
      if (clientId) {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          this.dealDto.productType,
          "",
          this.dealDto.id,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          identifier,
          this.orgCode,
          "",
          "Client",
          this.dealDto.organisationLinkId,
          this.dealDto.productType,
        );
      }
    }
  }

  calcContingencyAmount() {
    if (this.dealDto.contingency && this.dealDto.buildCosts) {
      this.contingencyAmount = this.dealDto.contingency * this.dealDto.buildCosts;
    } else {
      this.contingencyAmount = null;
    }
  }

  hasValidNetLoanRequiredValue() {
    if (
      !this.dealDto.maxLoanRequired &&
      (this.dealDto.netLoanRequired == null || isNaN(this.dealDto.netLoanRequired) || this.dealDto.netLoanRequired <= 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  /*getRegionByPostcode() {
            if (this.dealDto.postcodeSearchString && this.dealDto.postcodeSearchString.replace(" ", "").length >= 2) {
                if (DealHelper.isValidPostcodeString(this.dealDto.postcodeSearchString)) {
                    this.dataLoading = true;
                    DealHelper.getRegionByPostcode(this.dealDto.postcodeSearchString).then((response) => {
                        if (response.Location != null) {
                            this.dealDto.locations = response.Location;
                            this.showPostcodeErrorMessage = false;
                        } else {
                            this.postcodeErrorMsg = response.PostCodeErrorMessage;
                            this.showPostcodeErrorMessage = true;
                            if (this.dealDto.locations) this.dealDto.locations = null;
                        }
                    }).finally(() => {
                        this.dataLoading = false;
                    });
                } else {
                    this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
                    this.showPostcodeErrorMessage = true;
                    if (this.dealDto.locations) this.dealDto.locations = null;
                }
            } else {
                if (this.dealDto.locations) this.dealDto.locations = null;
            }
        }*/

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  getLoanInfoText() {
    switch (this.dealDto.productType) {
      case ProductTypeEnum.BridgingDeveloperExit:
        this.loanInfoText = "For properties that are at practical completion, but need more time to sell or refinance";
        break;
      case ProductTypeEnum.BridgingPurchaseOrRefinance:
        this.loanInfoText = "Loans against the property value only. Any improvement works need to be self-funded";
        break;
      case ProductTypeEnum.BridgingRefurb:
        this.loanInfoText = "Loans available against the property and the refurbishment works.";
        break;
      case ProductTypeEnum.BridgingPreconstruction:
        this.loanInfoText = "Loans for gaining planning or to amend existing planning";
        break;
      default:
        this.loanInfoText = "";
        break;
    }
  }

  clickNextButton() {
    if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
      this.logEvent("BRIDGINGCRITERIA-PAGE2");
    }
    this.progressSection = 2;
    this.progressAmount = "50%";
  }

  clickBackButton() {
    if (!this.isLoggedInUser && this.isValidEnterprisePath()) {
      this.logEvent("BRIDGINGCRITERIA-PAGE1");
    }
    this.progressSection = 1;
  }

  async logEventWithoutDealData() {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        await this.eventLogClient.logPageLoad(
          "BRIDGINGCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.BridgingPurchaseOrRefinance,
          "",
          0,
          Number(sessionStorage.getItem("clientId")),
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "BRIDGINGCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.BridgingPurchaseOrRefinance,
        );
      }
    } else {
      var clientId: number = null;
      clientId = Number(await this.organisationService.getData("clientId"));

      if (clientId) {
        await this.eventLogClient.logPageLoad(
          "BRIDGINGCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.BridgingPurchaseOrRefinance,
          "",
          0,
          clientId,
        );
      } else {
        await this.eventLogClient.logPageLoad(
          "BRIDGINGCRITERIA",
          this.orgCode,
          "",
          "Client",
          this.orgLinkId ? this.orgLinkId : null,
          ProductTypeEnum.BridgingPurchaseOrRefinance,
        );
      }
    }
  }

  postRetrieveProcessing(response) {
    this.dealDto = { ...response };
    this.currentUseOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.getLoanInfoText();
    this.snapshotDealDto = { ...response };
    this.isFamilyInResidence = this.dealDto.isFamilyInResidence == YesNoMaybe.Yes ? true : false;
    this.ownOrPurchase = this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own ? true : false;
    this.landOrProperty = this.dealDto.landOrProperty == LandOrPropertyEnum.Property ? true : false;
    //this.initClassUses();
    this.calcContingencyAmount();
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  isValidEnterprisePath() {
    const path = this.$location.path();
    const validPaths = ["/e/bridgingcriteria", "/allloans", "/enterprise"];

    return validPaths.some((prefix) => path.startsWith(prefix));
  }

  setShowVATBridgingModal() {
    this.showVATBridgingModal = true;
    this.eventLogClient.logPageLoad(
      "VATBRIDGING-CRITERIA-URL-CLICKED",
      "",
      (this.$rootScope as any)?.currentUser?.userName,
      "",
      null,
      this.dealDto.productType,
    );
  }
}
